import PropTypes from 'prop-types';
import { components } from 'react-select';
import { AgeFromDate, Icon } from '@febos-io/design';
import React from 'react';
import { useTranslation } from '../../hooks';

export function PatientOption({ label, data, ...props }) {
  const { t } = useTranslation();
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-center bg-hover-light-black rounded">
        <div className="position-relative d-flex align-items-center">
          <Icon icon={data.gender === 'female' ? 'venus' : 'mars'} fontSize="30" />
          <div className="ms-2">
            <span className="fs-4">{label}</span>
            <h6 className="mb-0 fw-semibold text-truncate w-75">{data.identificationNumber}</h6>
            <h6 className="mb-0 fw-semibold text-truncate w-75">{data.email}</h6>
          </div>
        </div>
        <div className="ms-auto">
          <span className="badge bg-light-success text-success rounded-pill">
            {t('Age')}
            :
            <AgeFromDate value={data?.birthDate} isIso />
          </span>
        </div>
      </div>
    </components.Option>
  );
}

PatientOption.propTypes = {
  label: PropTypes.string,
  data: PropTypes.shape({
    email: PropTypes.string,
    gender: PropTypes.string,
    birthDate: PropTypes.string,
    identificationNumber: PropTypes.string
  }).isRequired,
  props: PropTypes.any
};

export default PatientOption;
